import React from "react"
import "./index.scss"

interface TimeLineSliceTooltipProps {
	content: React.ReactNode
	props: any
}

const TimeLineSliceTooltip: React.FC<TimeLineSliceTooltipProps> = ({
	content,
	props,
}): JSX.Element => {
	const childrenWithProps = React.Children.map(content, (child) => {
		return React.cloneElement(child as any, {
			points: props.slice.points,
		})
	})

	return <div className="container-tooltip-timeline">{childrenWithProps}</div>
}

export default TimeLineSliceTooltip
